import {RSAA} from 'redux-api-middleware';

import {composeURL} from '../../utils/url';
import {showServerError} from '../../actions/notifications';

let linksListEndpoint,
    subredditsListEndpoint;

export const LINKS_LIST_REQUEST = '@@clientReddit/LINKS_LIST_REQUEST',
    LINKS_LIST_SUCCESS = '@@clientReddit/LINKS_LIST_SUCCESS',
    LINKS_LIST_ERROR = '@@clientReddit/LINKS_LIST_ERROR',
    SUBREDDITS_LIST_REQUEST = '@@clientReddit/SUBREDDITS_LIST_REQUEST',
    SUBREDDITS_LIST_SUCCESS = '@@clientReddit/SUBREDDITS_LIST_SUCCESS',
    SUBREDDITS_LIST_ERROR = '@@clientReddit/SUBREDDITS_LIST_ERROR',
    baseURL = 'https://www.reddit.com',
    linksList = (path, params = {}) => dispatch => {
        const endpoint = linksListEndpoint = composeURL(`${baseURL}${path}/.json`, {
            raw_json: 1,
            ...params
        });
        dispatch({
            [RSAA]: {
                bailout: () => linksListEndpoint !== endpoint,
                endpoint,
                method: 'GET',
                types: [
                    {
                        type: LINKS_LIST_REQUEST,
                        payload: {
                            endpoint
                        }
                    },
                    LINKS_LIST_SUCCESS, {
                        type: LINKS_LIST_ERROR,
                        payload: (action, state, response) => {
                            console.log('linksList error');
                            dispatch(showServerError(response, 8000));
                            return response;
                        }
                    }
                ]
            }
        });
    },
    subredditsList = (path, params = {}) => dispatch => {
        const endpoint = subredditsListEndpoint = composeURL(`${baseURL}/subreddits/default/.json`, {
            limit: 100,
            raw_json: 1,
            ...params
        });
        dispatch({
            [RSAA]: {
                bailout: () => subredditsListEndpoint !== endpoint,
                endpoint,
                method: 'GET',
                types: [
                    {
                        type: SUBREDDITS_LIST_REQUEST,
                        payload: {
                            endpoint
                        }
                    },
                    SUBREDDITS_LIST_SUCCESS, {
                        type: SUBREDDITS_LIST_ERROR,
                        payload: (action, state, response) => {
                            console.log('subredditsList error');
                            dispatch(showServerError(response, 8000));
                            return response;
                        }
                    }
                ]
            }
        });
    };


// WEBPACK FOOTER //
// ./src/apps/client-reddit/actions.js